document.addEventListener('DOMContentLoaded', () => {
    // Select all elements with image_left or image_right classes
    const images = document.querySelectorAll('.image_left, .image_right');

    // Create the observer
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('image-seen');
                // Stop observing once seen
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.5
    });

    // Observe each element
    images.forEach(img => observer.observe(img));
});
